import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faArchive } from '@fortawesome/pro-solid-svg-icons/faArchive';
import { faBarcodeScan } from '@fortawesome/pro-solid-svg-icons/faBarcodeScan';
import { faCloud } from '@fortawesome/pro-solid-svg-icons/faCloud';
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faEnvelopeOpen } from '@fortawesome/pro-solid-svg-icons/faEnvelopeOpen';
import { faRecycle } from '@fortawesome/pro-solid-svg-icons/faRecycle';
import { faShare } from '@fortawesome/pro-solid-svg-icons/faShare';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { IconDefinition, faShredder } from '@fortawesome/pro-solid-svg-icons';

export const MailActionsIconMap: Record<string, IconDefinition> = {
	'Return to Sender': faBan,
	'Open and Scan': faEnvelopeOpen,
	'Scan Remaining Pages': faBarcodeScan,
	Forward: faShare,
	'Physical Store': faArchive,
	'Digital Store': faCloud,
	Recycle: faRecycle,
	Shred: faShredder,
	Delete: faTrash,
	Email: faEnvelope,
	Download: faDownload,
};
